import React from 'react';
import { Badge, Text } from '../../core-ui';

import { AppStatus } from '../../core/constants/AppStatus';

type Status = ValueOf<typeof AppStatus>;

type StatusDescriptor = { getLabel: () => string; color: string };

const statusMap: Record<Status, StatusDescriptor> = {
  [AppStatus.PENDING]: {
    getLabel: () => t('Pending Review'),
    color: 'yellow',
  },
  [AppStatus.APPROVED]: {
    getLabel: () => t('Approved'),
    color: 'blue',
  },
  [AppStatus.ACTIVE]: {
    getLabel: () => t('Active'),
    color: 'green',
  },
  [AppStatus.DECLINED]: {
    getLabel: () => t('Declined'),
    color: 'red',
  },
  [AppStatus.WAITLISTED]: {
    getLabel: () => t('Waitlisted'),
    color: 'orange',
  },
};

// TODO: Better types: `status: Status` for both components below

export function StatusText(props: { status: string }) {
  const { status } = props;
  const descriptor = statusMap[status as Status];
  if (descriptor) {
    return <Text>{descriptor.getLabel()}</Text>;
  }
  return null;
}

export function StatusBadge(props: { status: string }) {
  const { status } = props;
  const descriptor = statusMap[status as Status];
  if (descriptor) {
    return (
      <Badge colorScheme={descriptor.color}>{descriptor.getLabel()}</Badge>
    );
  }
  return null;
}
